// Imports
import React from 'react';
import company from '../../../shareables/company';
import GlobalStyle from '../../../shareables/foundation/simple-ui/components/global-style';
import Header from '../../../shareables/foundation/simple-ui/components/header';
import Logo from '../../../shareables/front-end/svg-logo';
import { Content } from '../../app';
import Footer from '../footer';
import * as Sentry from '@sentry/browser';


// Component class
//  -> There are no Hooks for error boundary functions yet (https://reactjs.org/docs/error-boundaries.html)
class ErrorBoundary extends React.Component<
	{ children: React.ReactChild; storybookError?: true },
	{ hasError: boolean }
> {
	constructor(props: { children: React.ReactChild; storybookError?: true }) {
		super(props);
		this.state = { hasError: props.storybookError ?? false };
	}
	
	static getDerivedStateFromError() {
		return { hasError: true };
	}
	
	componentDidCatch(error: Error) {
		// Report to Sentry
		Sentry.captureException(error);
	}
	
	render() {
		if (this.state.hasError) {
			return (
				<React.StrictMode>
					<GlobalStyle />
					
					<Header logoElement={<Logo />} title='Start for free' />
					
					<Content>
						<strong>Oh snap!</strong> An unexpected issue occurred. If this persists, please{' '}
						{/* eslint-disable-next-line react/jsx-no-target-blank */}
						<a href={`https://help.${company.productionDomain ?? ''}/`} target='_blank'>
							contact us
						</a>
						.
					</Content>
					
					<Footer />
				</React.StrictMode>
			);
		}
		
		return this.props.children;
	}
}


// Export
export default ErrorBoundary;
